import { TBctxItems } from '@monorepo/types';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { selectedAppSettings } from '../app-master-db/app-master.query';
import * as fromBusinessContextItems from './work-items-db.reducer';

export const selectBusinessContextItems =
  createFeatureSelector<fromBusinessContextItems.TWorkItemsDatabases>('workItemsDB');

export const workItemDbReady = createSelector(selectBusinessContextItems, (workStationDb) => !!workStationDb.result);

export const hasWorkItems = createSelector(selectBusinessContextItems, (workStationDb) => {
  if (workStationDb.result.length) {
    return true;
  } else {
    return false;
  }
});

export const getAllStations = createSelector(selectBusinessContextItems, (wsDB) => wsDB.entities['STATIONS']);

export const getAllBundles = createSelector(selectBusinessContextItems, (wsDB) => wsDB.entities['BUNDLES']);

export const getSelectedBundleId = createSelector(selectBusinessContextItems, (wsDB) => wsDB.selectedBundleId);

export const getBctxItemsForAllBundle = createSelector(
  selectedAppSettings,
  getAllStations,
  getAllBundles,
  (appSettings, stations, bundles) => {
    if (appSettings) {
      console.log('getBctxItemsForAllBundle', appSettings, stations, bundles);
      return stations && stations[appSettings.stationId]
        ? stations[appSettings.stationId].bundles.map((v) => ({
            bundlesId: v,
            bundleItem: bundles[v].bundleItems[0].bctx_items,
          }))
        : [];
    }
    return [];
  },
);

export type TGetBctxItemsForAllBundle = ReturnType<typeof getBctxItemsForAllBundle>;
export type TBctxItemsForAllBundle = Exclude<TGetBctxItemsForAllBundle, null>;

export const getBundleInfo = createSelector(getSelectedBundleId, getAllBundles, (selectedBundleId, bundles) => {
  console.log(selectedBundleId, bundles);
  if (selectedBundleId) {
    return bundles[selectedBundleId];
  }
  return null;
});

export type TGetBundleInfo = ReturnType<typeof getBundleInfo>;
export type TBundleInfo = Exclude<TGetBundleInfo, null>;

export const getUniqueBctxItemsFromAllBundle = createSelector(getAllBundles, (bundles) => {
  console.log('[getUniqueBctxItemsFromAllBundle]', bundles);
  const unique_bctx_items: TBctxItems[] = [];
  Object.keys(bundles).map((bundleKey) => {
    unique_bctx_items.push(bundles[bundleKey].bundleItems[0].bctx_items);
  });
  return unique_bctx_items;
});

export type TGetUniqueBctxItemsFromAllBundle = ReturnType<typeof getUniqueBctxItemsFromAllBundle>;
export type TUniqueBctxItemsFromAllBundle = Exclude<TGetUniqueBctxItemsFromAllBundle, null>;
